// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FAQ_FORM_USERNAME = "Login (pokud jsi registrovan\u00e1)";
export const FAQ_FORM_WE_WILL_ANSWER_SOON = "V\u011bt\u0161inou odpov\u00edd\u00e1me do t\u0159\u00ed dn\u016f, sna\u017e\u00edme se v\u017edy co nejd\u0159\u00edve.";
export const FAQ_YOU_DID_NOT_ENTER_DESCRIPTION = "Nezadala jsi popis probl\u00e9mu";
export const HELP_FORM_ISSUE = "Popis situace / probl\u00e9mu";
export const HELP_FORM_TOPIC = "T\u00e9ma";
export const HELP_FORM_WHATS_NEXT_EMAIL = "Potvrzen\u00ed o p\u0159ijet\u00ed tv\u00e9 zpr\u00e1vy ti po\u0161leme na tv\u016fj email. Stejn\u011b tak p\u0159\u00edpadnou odpov\u011b\u010f. ";
